import Booking from '@/models/booking'

export default {
  bookingProfiles: [],
  bookings: [],
  selectedBookingProfileId: undefined,
  selectedBooking: new Booking().getObject(),
  selectedBookingProfile: undefined,
  currentPageNumber: 0,
  pageSize: 10,
  nextAvailablePage: undefined
}
